import { render } from "./FormDetailsStep.vue?vue&type=template&id=5be6a586&scoped=true"
import script from "./FormDetailsStep.vue?vue&type=script&lang=js"
export * from "./FormDetailsStep.vue?vue&type=script&lang=js"

import "./FormDetailsStep.vue?vue&type=style&index=0&id=5be6a586&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be6a586"]])

export default __exports__